import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { Trans } from 'react-i18next'
import { model as i18n } from '~/core/i18n'
import { $guestRegistrationLink } from '~/features/signin-to-watch'

export function DescriptionWithLink(): JSX.Element | string {
  const guestRegistrationLink = useUnit($guestRegistrationLink)

  const { t } = useUnit(i18n.$t)

  if (guestRegistrationLink) {
    return (
      <Trans
        t={t}
        i18nKey='login_or_register_to_watch_content_link'
        components={{
          1: (
            <a
              href={guestRegistrationLink}
              target='_blank'
              rel='noreferrer'
              style={{ textDecoration: 'underline' }}
            />
          ),
        }}
      />
    )
  }

  return t('login_or_register_to_watch_content')
}
